import {
  AssetField,
  TableAssetType,
} from '@elementary/common-ui/services/gql/types';
import { capitalize } from '@elementary/common-ui/utils/common';
import { GroupTitleFormatters } from 'shared/types';

export const MODEL_RUNS_TABLE_TYPES: TableAssetType[] = ['MODEL', 'SNAPSHOT'];

export const COLUMN_TO_FIELD_MAP: Record<string, AssetField> = {
  name: 'NAME',
  database_name: 'DATABASE_NAME',
  schema: 'SCHEMA_NAME',
  status: 'LAST_EXECUTION_STATUS',
  last_exec_time: 'LAST_EXECUTION_DURATION',
  median_exec_time: 'MEDIAN_DURATION',
  exec_time_change_rate: 'CHANGE_RATE',
  totals: 'ERROR_COUNT',
  'asset_metadata.owners': 'OWNER',
  'asset_metadata.tags': 'TAG',
  'asset_metadata.subscribers': 'SUBSCRIBER',
  'asset_metadata.materialization': 'BUILD_STRATEGY',
  'asset_metadata.is_critical': 'IS_CRITICAL',
  'asset_metadata.path': 'PATH',
};

const SORT_ONLY_COLUMN_IDS = [
  'last_exec_time',
  'median_exec_time',
  'exec_time_change_rate',
  'totals',
];

export const FILTERABLE_COLUMN_TO_FIELD_MAP: Record<string, AssetField> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).filter(
      ([column]) => !SORT_ONLY_COLUMN_IDS.includes(column),
    ),
  );

export const FIELD_TO_COLUMN_MAP: Partial<Record<AssetField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );

const keepValue = (value: string) => value;

export const GROUP_TITLE_FORMATTERS: GroupTitleFormatters = {
  database_name: keepValue,
  schema: keepValue,
  status: capitalize,
  'asset_metadata.materialization': capitalize,
  'asset_metadata.is_critical': (value) =>
    value === 'true' ? 'Critical Asset' : 'Not Critical',
};

export const GROUPABLE_COLUMN_IDS = Object.keys(GROUP_TITLE_FORMATTERS);
